import { useEffect, useState } from 'react';

import type React from 'react';
import 'intersection-observer';

export const useOnScreen = (ref: React.RefObject<HTMLElement>): boolean => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  /* eslint-disable no-undef */
  const observer = new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting));

  useEffect((): void | (() => void) => {
    if (ref.current) {
      observer.observe(ref.current);
      // Remove the observer as soon as the component is unmounted
      return (): void => {
        observer.disconnect();
      };
    }
  }, [ref.current]);

  return isIntersecting;
};
